// extracted by mini-css-extract-plugin
export default {"container":"gL-z","topReviewHeading":"hL-z","criticalReview":"iL-z","favorableReview":"jL-z","vsSeparator":"kL-z"};